import Store from 'store/store'
import { render } from 'utils/jsx'

import APIServer from 'controllers/api-server'

import Modal from 'components/dom/Modal'

export default function ({ title = 'Aide', tone = 'neutral' } = {}) {
  const messages = Store.app.helpMessages.get()
  const index = Store.steps.index.get()

  APIServer.log('help')

  render((
    <Modal title={title} tone={tone}>
      {messages[index]}
    </Modal>
  ), document.body)
}



// WEBPACK FOOTER //
// ./src/controllers/help.js